import { useEffect } from "react";
import { useSiteSettings } from "./useSiteSettings";

/**
 * useFavicon
 * ------------
 * Applies the real admin-uploaded favicon (Admin > Website Settings) to
 * the browser tab icon. Extracted out of ThemeProvider.jsx (which does
 * this plus a bunch of public-site-only brand color CSS variables) so the
 * admin panel - which intentionally does NOT want the public site's brand
 * colors, but does want the same real favicon - can pick up just this one
 * behaviour without pulling in ThemeProvider wholesale. Before this,
 * ThemeProvider only ever wrapped the public site (see App.js's
 * PublicSite component), so /admin always showed the static default
 * favicon.png baked into index.html at build time, never whatever an
 * admin actually uploaded.
 */
export function useFavicon() {
  const { faviconUrl } = useSiteSettings();
  useEffect(() => {
    if (!faviconUrl) return;
    const links = document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"]');
    links.forEach((link) => { link.href = faviconUrl; });
  }, [faviconUrl]);
}
